// ============================================================================
// TAFSIRI ZA KISWAHILI - YESU SI...
// ============================================================================
// Ufafanuzi muhimu kuhusu ni nani Yesu kweli

export const jesusIsNot = [
  {
    "category": "upendo",
    "text": "Yesu si mchukia watu wa jinsia moja - Upendo wake usio na kikomo unajumuisha kila mtu kama walivyo",
    "reference": "1 Yohana 4:8 - Mungu ni upendo",
    "context": "Upendo wa Mungu ni wa kujumuisha na unakubali kila mtu katika utofauti wake"
  },
  {
    "category": "usawa",
    "text": "Yesu si mchukia wanawake - Upendo wake usio na kikomo unawathamini wanawake wote",
    "reference": "Luka 8:1-3 - Wanawake waliofuata Yesu",
    "context": "Yesu anafanya mapinduzi ya wakati wake kwa kujumuisha na kuheshimu wanawake"
  },
  {
    "category": "amani",
    "text": "Yesu si muuaji - Upendo wake usio na kikomo unawapa wote uzima",
    "reference": "Yohana 10:10 - Nimekuja ili wawe na uzima",
    "context": "Yesu analeta uzima, uponyaji na urejeshaji kwa kila mtu"
  },
  {
    "category": "umoja",
    "text": "Yesu si mgawanyaji - Upendo wake usio na kikomo unawaungamiza wanadamu wote",
    "reference": "Wagalatia 3:28 - Hakuna Myahudi wala Mgiriki",
    "context": "Upendo wa Yesu unavuka vizuizi vyote vya kibinadamu"
  },
  {
    "category": "upendo",
    "text": "Yesu si mbaguzi wa rangi - Upendo wake usio na kikomo unakumbatia tamaduni zote",
    "reference": "Mathayo 28:19 - Fanyeni mataifa yote kuwa wanafunzi",
    "context": "Upendo wa Yesu unasherehekea utofauti wa wanadamu wote"
  },
  {
    "category": "haki",
    "text": "Yesu si mdhalimu - Upendo wake usio na kikomo unawakomboa na kuwaponya wote",
    "reference": "Luka 4:18 - Amenituma kuhubiri wafungwa wapate uhuru",
    "context": "Upendo wa Yesu unaleta uhuru na uponyaji kwa wote"
  },
  {
    "category": "unyenyekevu",
    "text": "Yesu si mwenye kiburi - Upendo wake usio na kikomo unawahudumia wote",
    "reference": "Wafilipi 2:7 - Alijidhili mwenyewe",
    "context": "Upendo wa Yesu unaonyeshwa kupitia unyenyekevu na huduma"
  },
  {
    "category": "msamaha",
    "text": "Yesu si mlipiza kisasi - Upendo wake usio na kikomo husamehe daima",
    "reference": "Luka 23:34 - Baba, wasamehe, kwa maana hawajui wanachofanya",
    "context": "Upendo wa Yesu unatoa msamaha hata katika mateso"
  },
  {
    "category": "huruma",
    "text": "Yesu si mtu asiye na hisia - Upendo wake usio na kikomo unahisi kila uchungu",
    "reference": "Yohana 11:35 - Yesu alilia",
    "context": "Upendo wa Yesu unashiriki kwa undani furaha na huzuni zetu"
  },
  {
    "category": "kweli",
    "text": "Yesu si mwongo - Upendo wake usio na kikomo ni kweli safi",
    "reference": "Yohana 14:6 - Mimi ndimi njia na kweli na uzima",
    "context": "Upendo wa Yesu ni kweli halisi zaidi inayopo"
  },
  {
    "category": "amani",
    "text": "Yesu si mwenye jeuri - Upendo wake usio na kikomo unaleta amani ya kweli",
    "reference": "Mathayo 5:9 - Heri waletao amani",
    "context": "Upendo wa Yesu unabadilisha migogoro kuwa upatanisho"
  },
  {
    "category": "ukarimu",
    "text": "Yesu si mwenye uchoyo - Upendo wake usio na kikomo unatoa bila kipimo",
    "reference": "2 Wakorintho 8:9 - Kwa ajili yenu alikuwa maskini",
    "context": "Upendo wa Yesu ni wa ukarimu hadi hatua ya kutoa kila kitu"
  },
  {
    "category": "upendo",
    "text": "Yesu si wa upendeleo - Upendo wake usio na kikomo unakaribisha kila kiumbe kipekee",
    "reference": "Matendo 10:34 - Mungu hapendelei uso wa mtu",
    "context": "Upendo wa Yesu unasherehekea upekee wa kila mtu, ikijumuisha ulemavu"
  },
  {
    "category": "ulimwengu wote",
    "text": "Yesu hana mipaka - Upendo wake usio na kikomo unavuka mipaka yote",
    "reference": "Warumi 10:12 - Hakuna tofauti kati ya Myahudi na Mgiriki",
    "context": "Hakuna mpaka kwa Yesu: wala wa kijiografia, wala wa kitamaduni, wala wa kijamii"
  },
  {
    "category": "heshima",
    "text": "Yesu si asiye na heshima - Anafundisha kujiheshimu, kuheshimu wanawake, kuheshimu wengine",
    "reference": "Mathayo 22:39 - Mpende jirani yako kama nafsi yako",
    "context": "Heshima ni hekima ya hakika: heshimu maisha yako, mwili wako, mwanamke kama wewe mwenyewe, wengine"
  },
  {
    "category": "amani",
    "text": "Yesu si mgawanyaji - Anawaungamiza Wayahudi, Waarabu na madhehebu yote katika amani",
    "reference": "Waefeso 2:14 - Yeye ni amani yetu, aliyewafanya wawili kuwa mmoja",
    "context": "Tushangilie utofauti wetu badala ya kuufanya kuwa magomano ya maneno na vita"
  },
  {
    "category": "kweli",
    "text": "Yesu si mwongo - Anafichua uongo na udanganyifu",
    "reference": "Yohana 8:44 - Shetani ni baba wa uongo",
    "context": "Yesu anafichua uongo na udanganyifu unaoughadhibu roho"
  },
  {
    "category": "ukarimu",
    "text": "Yesu si mchoyo - Ukarimu wake unazidi sana zaka",
    "reference": "Luka 21:3 - Mjane huyu maskini ameweka zaidi ya wote",
    "context": "Ukarimu wa Yesu ni mkuu kuliko wajibu wa zaka"
  },
  {
    "category": "haki",
    "text": "Yesu si mshirika wa kimya - Analinda kupitia haki ya afya",
    "reference": "Mathayo 18:6 - Yeyote atakayemkwaza mmoja wa hawa wadogo",
    "context": "Kimya kinachofunika makosa bila kulinda wengine si hekima ya Yesu"
  }
];

export default jesusIsNot;
